import classNames from 'classnames';
import type React from 'react';
import type { BgColors } from '../../constants';
import { ContentEditableInput } from '../Form';
import { TooltipBubble } from '../TooltipBubble';
import { TextBase, TextPageHeader } from '../Typography';

export interface PageHeaderProps {
  title: string;
  subTitle?: string;
  onEdit?: (value: string) => void;
  buttons?: React.ReactNode;
  breadcrumbs?: React.ReactNode;
  icon?: React.ReactNode;
  truncateWidth?: number;
  backgroundColor?: BgColors;
}

export const PageHeader = ({
  title,
  subTitle,
  buttons,
  onEdit,
  breadcrumbs,
  icon,
  truncateWidth = 384,
  backgroundColor = 'bg-ds-accent3-100',
}: PageHeaderProps) => {
  return (
    <div
      className={`flex flex-col py-8 w-full ${backgroundColor} items-center justify-center`}
    >
      <div className="w-ds-page ">
        {breadcrumbs && <div>{breadcrumbs}</div>}
        <div
          className={classNames('flex w-full justify-between ', {
            'mt-5': breadcrumbs,
          })}
        >
          <div className="flex items-center overflow-hidden overflow-ellipsis whitespace-nowrap">
            {icon && title && <div className="mr-2.5">{icon}</div>}

            {onEdit ? (
              <div className="w-ds-400">
                <ContentEditableInput
                  onChange={onEdit}
                  inputSize="xxl"
                  bordered
                >
                  <TooltipBubble
                    placement="top-start"
                    title={title}
                  >
                    <div className="flex items-center whitespace-nowrap rounded-md pl-1">
                      <TextPageHeader
                        ellipsis
                        label={title}
                        color="text-ds-natural-600"
                      />
                    </div>
                  </TooltipBubble>
                </ContentEditableInput>
              </div>
            ) : (
              <div
                className={classNames({
                  'flex flex-col': subTitle,
                })}
              >
                <TooltipBubble
                  placement="top-start"
                  title={title}
                >
                  <div
                    className="flex items-center truncate whitespace-nowrap"
                    style={{
                      maxWidth: `${truncateWidth}px`,
                    }}
                  >
                    <TextPageHeader
                      ellipsis
                      label={title}
                      color="text-ds-natural-600"
                    />
                  </div>
                </TooltipBubble>
                {subTitle && (
                  <div className="mt-4">
                    <TextBase
                      label={subTitle}
                      color="text-ds-natural-600"
                    />
                  </div>
                )}
              </div>
            )}
          </div>
          <div className="flex items-center">{buttons}</div>
        </div>
      </div>
    </div>
  );
};
